// Angular
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {NgxPermissionsService} from 'ngx-permissions';
import {AlertService} from '../../services/alert.service';

@Component({
  selector: 'app-modulo-seguridad',
  templateUrl: './modulo-seguridad.component.html',
  styleUrls: ['./modulo-seguridad.component.scss']
})
export class ModuloSeguridadComponent implements OnInit {
  tabselected
  constructor(
    private activateRoute: ActivatedRoute,
    private ngxPermissionService: NgxPermissionsService,
    private alertService: AlertService,
    ) {
    if (this.activateRoute.snapshot.paramMap.get('accion') != null) {
      this.tabselected=this.activateRoute.snapshot.paramMap.get('accion')
    }

   }

  ngOnInit(): void {
  }
  selecttab(tab) {
    this.tabselected = tab
  }
}
